import { Map, List } from 'immutable';
import { FORM_IS_TOUCHED, FORM_IS_UNTOUCHED, SET_EXPANDED_CARD_INDEX } from './constants';

const initialState = Map({
  isTouched: true,
});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case FORM_IS_TOUCHED: {
      return state.set('isTouched', true);
    }

    case FORM_IS_UNTOUCHED: {
      return state.set('isTouched', false);
    }

    case SET_EXPANDED_CARD_INDEX: {
      const { index } = action;
      return state.set('expandedCardIndex', index);
    }

    default: {
      return state;
    }
  }
};
